import { Breadcrumb } from "@gull";
import { useCallback, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import overlayFactory from "react-bootstrap-table2-overlay";
import HandyScroll from "app/common/Scroll";
import usePagePermission from "app/hooks/usePagePermission";
import { exportBookedFlight } from "app/services/AdminServices/bookingService";
import queryString from "app/services/queryStringService";
import moment from "moment";
import Tooltip from "rc-tooltip";
import { Badge, Button, Col, Image, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { FaArrowsAltH, FaLongArrowAltRight } from "react-icons/fa";
import { MdOutlineRefresh, MdSearch } from "react-icons/md";

import {
  getAirlineDetailsForReport,
  getAirportsDetailsForReport,
  getAreaSalesManagerAutoCompleteForReport,
  getCountryDetailsForReport,
  getSalesExecutiveAutoComplete,
  getSalesExecutiveAutoCompleteForReport,
  getSalesManagerAutoCompleteForReport,
  getSalesReport,
  getSalesUserForReport,
  getSeniorExecutiveAutoCompleteForReport,
  getSeniorManagerReport,
  getStateDetailsForReport,
  getSupplierForReport,
} from "app/services/ReportListService";
import { AiFillFileExcel } from "react-icons/ai";
import CommonAutoComplete from "./Components/CommonAutoComplete";
import HierarchyAutoComplete from "./Components/HierarchyAutoComplete";
import {
  getAreaSalesManagerAutoComplete,
  getRegionalManagerAutoComplete,
  getSalesManagerAutoComplete,
  getSeniorExecutiveAutoComplete,
} from "app/services/RegionService";
import SeniorExecutiveAutocomplete from "../SalesRegion/Components/SeniorExecutiveAutocomplete";

function SeniorSalesExecutive() {
  const [isShowGlobalFilter, setIsShowGlobalFilter] = useState(true);
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  // console.log({ canAdd, canView, canEdit, canDelete });

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const initialData = {
    fromDate: "",
    toDate: "",
    searchBy: "Booking",
    airlineWise: null,
    fromOrigin: null,
    destinationWise: null,
    countryId: null,
    stateId: null,
    supplierWise: null,
    // SalesEecutiveId: null,
    RegionalManagerId: null,
    SalesManagerId: null,
    AreaSalesManagerId: null,
    SeniorEecutiveId: null,
    SalesEecutiveId: null,
  };
  const [filters, setFilters] = useState(initialData);

  const dateFormatter = useCallback((cell) => {
    return cell ? (
      <div>
        <div>{moment(cell).format("DD/MM/YYYY")}</div>
        <div>{moment(cell).format("HH:mm")}</div>
      </div>
    ) : (
      "-"
    );
  }, []);

  const priceFormatter = useCallback((cell) => {
    return (
      <span className="text-center">₹ {parseFloat(cell ?? 0).toFixed(2)}</span>
    );
  }, []);

  const gatewayFormatter = (cell, row) => {
    return cell == "TRAVELPORT_GAL" ? "TRAVELPORT GAL" : cell;
  };

  const JourneyType = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <div>
        {row.journeyType == 1 ? (
          <>
            <div style={{ marginBottom: 5 }}>
              {row.flightCarrier.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row.flightCarrier.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                      alt=""
                      height="20"
                      width={"20"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row.flightCarrier.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                    alt=""
                    height="20"
                    width={"20"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row.flightCarrier.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg={row.isDomestic == true ? "info" : "danger"}>
                {row.isDomestic == true ? "Domestic" : "International"} Oneway
              </Badge>
            </h6>
          </>
        ) : row.journeyType == 2 ? (
          <>
            <div style={{ marginBottom: 5, borderRadius: 15 }}>
              {row.flightCarrier.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row.flightCarrier.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                      alt=""
                      height="20"
                      width={"20"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row.flightCarrier.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                    alt=""
                    height="20"
                    width={"20"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row.flightCarrier.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg="warning" style={{ color: "black" }}>
                Domestic Return
              </Badge>
            </h6>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 5 }}>
              {row.flightCarrier.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row.flightCarrier.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                      alt=""
                      height="22"
                      width={"22"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row.flightCarrier.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                    alt=""
                    height="22"
                    width={"22"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row.flightCarrier.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg="primary">International Return</Badge>
            </h6>
          </>
        )}
      </div>
    );
  };

  const flightFormatter = useCallback((cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <>
        {row.journeyType == 1 ? (
          <Tooltip
            placement="top"
            overlay={
              <div style={{ maxWidth: 250 }}>
                {row.airportDeparture.cityName} <FaLongArrowAltRight />{" "}
                {row.airportDestination.cityName}
              </div>
            }
          >
            <span>
              {row.airportDeparture.cityCode} <FaLongArrowAltRight />{" "}
              {row.airportDestination.cityCode}
            </span>
          </Tooltip>
        ) : (
          <Tooltip
            placement="top"
            overlay={
              <div style={{ maxWidth: 250 }}>
                {row.airportDeparture.cityName} <FaArrowsAltH />{" "}
                {row.airportDestination.cityName}
              </div>
            }
          >
            <span>
              {row.airportDeparture.cityCode} <FaArrowsAltH />{" "}
              {row.airportDestination.cityCode}
            </span>
          </Tooltip>
        )}
      </>
    );
  }, []);

  const CarrierChargesFormatter = (cell, row) => {
    return (
      <>
        {row.flightCommissionType == "Negative" ? (
          <span className="text-center" style={{ color: "red" }}>
            ₹ {parseFloat(cell).toFixed(2)}
          </span>
        ) : row.flightCommissionType == "Positive" ? (
          <span className="text-center" style={{ color: "green" }}>
            ₹ {parseFloat(cell).toFixed(2)}
          </span>
        ) : (
          <span className="text-center text-primary">
            ₹ {parseFloat(cell).toFixed(2)}
          </span>
        )}
      </>
    );
  };
  const yQYrFormatter = (cell, row) => (
    <span className="text-center">
      ₹ {parseFloat(row.yqFare ?? 0).toFixed(2)} / ₹{" "}
      {parseFloat(row.yrFare ?? 0).toFixed(2)}
    </span>
  );
  const tdsAmount = (cell, row) => {
    const oldTds = row?.tdsAmount ?? 0;
    const newTds = row?.carrierCommTDS;
    return (
      <>
        <span className="text-center" style={{ color: "red" }}>
          ₹ {parseFloat(oldTds ?? newTds).toFixed(2)}
        </span>
      </>
    );
  };
  const gstComm = (cell, row) => {
    return (
      <>
        <span className="text-center" style={{ color: "red" }}>
          ₹ {Math.abs(cell ?? 0).toFixed(2)}
        </span>
      </>
    );
  };
  const commissionWithGST = (cell, row) => {
    const gst = row?.carrierCommGst ?? 0;
    const comm = row?.totalCarrierServiceCharges ?? 0;
    return (
      <>
        <span className="text-center" style={{ color: "red" }}>
          ₹ {Math.abs(comm - gst).toFixed(2)}
        </span>
      </>
    );
  };

  const userType = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <>
        <Row>
          <Col
            style={{
              textTransform: "uppercase",
            }}
          >
            <div>{row?.masterMember?.company}</div>
            <div>{row.user.normalizedUserName}</div>
          </Col>
        </Row>
      </>
    );
  };
  const bookBy = (cell, row) => {
    const value = row?.bookedByUser || "";
    const parts = value.split("-");

    let role = "";
    let userId = "";
    let name = "";

    if (parts.length >= 4) {
      role = `${parts[0]} ${parts[1]}`; // Sub-Merchant
      userId = parts[2];
      name = parts.slice(3).join("-"); // handles extra hyphens
    } else if (parts.length === 3) {
      role = parts[0];
      userId = parts[1];
      name = parts[2];
    }

    return (
      <Row>
        {row?.bookedByUser ? (
          <Col
            style={{
              textTransform: "uppercase",
            }}
          >
            <div>
              {userId} ({role})
            </div>
            {/* <div>{userId}</div> */}
            <div>{name}</div>
          </Col>
        ) : (
          <Col>-</Col>
        )}
      </Row>
    );
  };

  const pnrFormatter = (cell, row) => {
    return (
      <>
        {row.currentStatus == "PENDING" || row.currentStatus == "REFUND" ? (
          ""
        ) : (
          <Tooltip placement="top" overlay={<div>{row.pnr}</div>}>
            <span>
              <Button variant="outline-primary" size="sm">
                Check PNR
              </Button>
            </span>
          </Tooltip>
        )}
      </>
    );
  };
  const gdsPnrFormatter = (cell, row) => {
    return (
      <>
        {row.currentStatus == "PENDING" || row.currentStatus == "REFUND" ? (
          ""
        ) : (
          <Tooltip placement="top" overlay={<div>{row.gdsPnr}</div>}>
            <span>
              <Button variant="outline-primary" size="sm">
                Check GDS PNR
              </Button>
            </span>
          </Tooltip>
        )}
      </>
    );
  };
  const billNumberFormat = (cell, row) => {
    if (!row?.billNumber) return "-";
    const parts = row.billNumber.split(" by ");
    const id = parts[0]?.trim() || "";
    const name = parts[1]?.trim() || "";
    return (
      <>
        <div>{id}</div>
        <div
          style={{
            textTransform: "uppercase",
          }}
        >
          {name}
        </div>
      </>
    );
  };
  const ModifyBy = (cell, row) => {
    const value = row?.modifiedByUser || "";
    const parts = value.split("-");

    let role = "";
    let userId = "";
    let name = "";

    if (parts.length >= 4) {
      role = `${parts[0]} ${parts[1]}`; // Sub-Merchant
      userId = parts[2];
      name = parts.slice(3).join("-"); // handles extra hyphens
    } else if (parts.length === 3) {
      role = parts[0];
      userId = parts[1];
      name = parts[2];
    }

    return (
      <>
        {row?.modifiedByUser || row.modifiedDate ? (
          <Row>
            <Col
              lg={12}
              style={{
                textTransform: "uppercase",
              }}
            >
              <div>
                {userId} ({role})
              </div>
              {/* <div>{userId}</div> */}
              <div>{name}</div>
            </Col>
            <Col lg={12}>{dateFormatter(row.modifiedDate, row)}</Col>
          </Row>
        ) : (
          <>-</>
        )}
      </>
    );
  };
  const issueDateFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return cell ? (
      <div>
        <div>{moment(cell).format("DD/MM/YYYY")}</div>
        <div>{moment(cell).format("HH:mm")}</div>
      </div>
    ) : (
      <div>
        <div>{moment(row.invoiceDate).format("DD/MM/YYYY")}</div>
        <div>{moment(row.invoiceDate).format("HH:mm")}</div>
      </div>
    );
  };
  const columns = [
    {
      dataField: "journeyType",
      text: "Airlines",
      formatter: JourneyType,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "invoiceDate",
      text: "Booking Date",
      formatter: dateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "110px", textAlign: "center" };
      },
    },
    {
      dataField: "modifiedDate",
      text: "Issue Date",
      formatter: issueDateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "110px", textAlign: "center" };
      },
    },
    {
      dataField: "airportDeparture.cityCode",
      text: "From - To",
      formatter: flightFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "departureDate",
      text: "Journey Date",
      formatter: dateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },

    {
      dataField: "pnr",
      text: "PNR",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: pnrFormatter,
    },
    {
      dataField: "gdsPnr",
      text: "GDS PNR",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: gdsPnrFormatter,
    },
    {
      dataField: "currentStatus",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },

    {
      dataField: "user.normalizedUserName",
      text: "User",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
      formatter: userType,
    },
    {
      dataField: "subMerchantName",
      text: "Book By",
      headerStyle: (colum, colIndex) => {
        return { width: "250px", textAlign: "center" };
      },
      formatter: bookBy,
    },
    {
      dataField: "modifiedByUser",
      text: "Modify By",
      formatter: ModifyBy,
      headerStyle: (colum, colIndex) => {
        return { width: "250px", textAlign: "center" };
      },
    },

    {
      dataField: "apiGateway",
      text: "Gateway",

      headerStyle: (colum, colIndex) => {
        return { width: "110px", textAlign: "center" };
      },
      formatter: gatewayFormatter,
    },
    {
      dataField: "bookingMode",
      text: "Booking Mode",

      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },
    {
      dataField: "publishTotalFare",
      text: "Booked Total Price",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "netTotalFare",
      text: "Booked Net Price",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },

    {
      dataField: "baseFare",
      text: "Base Price",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "taxFare",
      text: "Tax Price",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "yqFare",
      text: "YQ / YR",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: yQYrFormatter,
    },
    {
      dataField: "totalCarrierServiceCharges",
      text: "Commission without GST",
      headerStyle: (colum, colIndex) => {
        return { width: "180px", textAlign: "center" };
      },
      formatter: CarrierChargesFormatter,
    },
    {
      dataField: "carrierCommGst",
      text: "GST Commission",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: gstComm,
    },
    {
      dataField: "adminTotalGst",
      text: "Commission with GST",
      headerStyle: (colum, colIndex) => {
        return { width: "180px", textAlign: "center" };
      },
      formatter: commissionWithGST,
    },

    {
      dataField: "tdsAmount",
      text: "TDS Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: tdsAmount,
    },

    {
      dataField: "adminMarkupAmount",
      text: "Markup",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "refundStatus",
      text: "Refund Status",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },
    {
      dataField: "billNumber",
      text: "Bill Number",
      headerStyle: (colum, colIndex) => {
        return { width: "180px", textAlign: "center" };
      },
      formatter: billNumberFormat,
    },
  ];

  function rowStyle(row, rowIndex) {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    if (row.currentStatus === "REJECTED") {
      style.backgroundColor = "#DCDCDC";
    }
    if (row.hasFrequentFlyer) {
      style.backgroundColor = "#f5ebff";
    }
    return style;
  }

  function NoDataIndication() {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  }

  const handleSearchChanges = useCallback((e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const getDistinctRecords = useCallback((records) => {
    const map = new Map();

    records.forEach((item) => {
      if (item.combo === false && item.combo !== null) {
        map.set(`${item.id}_${Math.random()}`, item);
        return;
      }

      const key = item.coRelationId;

      if (!map.has(key)) {
        map.set(key, []);
      }

      map.get(key).push(item);
    });

    const result = [];

    map.forEach((group) => {
      if (!Array.isArray(group)) {
        result.push(group);
        return;
      }

      const lastOccurrence = {
        ...group[group.length - 1],
      };

      const totals = group.reduce(
        (acc, entry) => {
          acc.netTotalFare += entry.netTotalFare || 0;
          acc.publishTotalFare += entry.publishTotalFare || 0;
          acc.baseFare += entry.baseFare || 0;
          acc.taxFare += entry.taxFare || 0;
          acc.yqFare += entry.yqFare || 0;
          acc.yrFare += entry.yrFare || 0;
          acc.totalCarrierServiceCharges +=
            entry.totalCarrierServiceCharges || 0;
          acc.carrierCommGst += entry.carrierCommGst || 0;
          acc.tdsAmount += entry.tdsAmount || 0;
          acc.carrierCommTDS += entry.carrierCommTDS || 0;

          return acc;
        },
        {
          netTotalFare: 0,
          publishTotalFare: 0,
          baseFare: 0,
          taxFare: 0,
          yqFare: 0,
          yrFare: 0,
          totalCarrierServiceCharges: 0,
          carrierCommGst: 0,
          tdsAmount: 0,
          carrierCommTDS: 0,
        },
      );

      Object.assign(lastOccurrence, totals);

      lastOccurrence.hasFrequentFlyer = group.some((entry) =>
        entry.passengerList?.some(
          (passenger) =>
            passenger.frequentFlyerNo &&
            passenger.frequentFlyerNo.trim() !== "",
        ),
      );

      result.push(lastOccurrence);
    });

    return result;
  }, []);
  const loadBookingDetails = useCallback(async () => {
    try {
      setLoading(true);

      const query = queryString.getQueryStringFromObj({
        pageNumber: page,
        pageSize: sizePerPage,

        ...Object.fromEntries(
          Object.entries(filters).map(([key, value]) => [
            key,
            typeof value === "object" && value !== null ? value.id : value,
          ]),
        ),
      });

      const response = await getSeniorManagerReport(query);

      const distinctRecords = getDistinctRecords(response.data.data);

      const paginationData = JSON.parse(response.headers["x-pagination"]);

      setData(distinctRecords);
      setDataCount(paginationData.TotalCount);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [filters, page, sizePerPage, getDistinctRecords]);

  useEffect(() => {
    loadBookingDetails();
  }, [loadBookingDetails]);

  useEffect(() => {
    const isValid =
      (filters.depart && filters.depart.length >= 3) ||
      (filters.arrival && filters.arrival.length >= 3) ||
      (filters.paxName && filters.paxName.length >= 3);

    if (!isValid) return;

    const timer = setTimeout(() => {
      setPage(1); // reset pagination
      loadBookingDetails();
    }, 500); // debounce

    return () => clearTimeout(timer);
  }, [filters.depart, filters.arrival, filters.paxName]);

  const handleSearch = useCallback(() => {
    setPage(1);
    loadBookingDetails();
  }, [loadBookingDetails]);

  const refreshFilter = useCallback(() => {
    setFilters(initialData);
  }, []);
  const handleExport = useCallback(async () => {
    try {
      setLoading(true);

      const query = queryString.getQueryStringFromObj({
        // pageNumber: page,
        // pageSize: sizePerPage,

        ...Object.fromEntries(
          Object.entries(filters).map(([key, value]) => [
            key,
            typeof value === "object" && value !== null ? value.id : value,
          ]),
        ),
      });

      const response = await exportBookedFlight(query);

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");

      link.href = url;

      link.setAttribute(
        "download",
        `${moment().format("YYYYMMDD_HHmmss")}_Flight_Booked_List.xlsx`,
      );

      document.body.appendChild(link);

      link.click();

      link.remove();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  const handleTableChange = useCallback((type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  }, []);

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const refreshGlobalFilter = async (e) => {
    setIsShowGlobalFilter(!isShowGlobalFilter);
  };

  return (
    <>
      <Helmet>
        <title>Senior Sales Executive Booking History</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Senior Sales Executive Booking History" }]}
      ></Breadcrumb>
      <div className="bookingList-header" style={{ marginBottom: 20 }}>
        <Row className="align-items-center mb-2">
          <Col className="col-md-12 d-flex justify-content-end mt-1">
            <Button
              variant="primary"
              className="mx-2"
              onClick={refreshGlobalFilter}
            >
              {isShowGlobalFilter ? (
                <>
                  Filter <i className="i-Filter-2 mt-1" />
                </>
              ) : (
                <i className="i-Filter-2 mt-1" />
              )}
            </Button>

            <Button
              variant="primary"
              onClick={handleExport}
              disabled={!dataCount}
            >
              {isShowGlobalFilter ? (
                <>
                  Export <AiFillFileExcel size={15} />
                </>
              ) : (
                <AiFillFileExcel size={15} />
              )}
            </Button>
          </Col>
        </Row>
        <div className={isShowGlobalFilter ? "collapse" : "show"}>
          <div className="card card-body rounded border mb-1">
            {/* <Row>
              <Col md={2} col={12}>
                <label>Search By</label>
                <select
                  className="form-select"
                  name="SearchBy"
                  value={filters.searchBy}
                  onChange={handleSearchChanges}
                >
                  <option value="Booking">Booking</option>
                  <option value="Travel">Travel</option>
                  <option value="Issue_Date">Issue Date</option>
                </select>
              </Col>
              <Col md={2} col={12}>
                <label>Date From</label>
                <input
                  type="date"
                  className="form-control"
                  name="fromDate"
                  value={filters.fromDate}
                  onChange={handleSearchChanges}
                  max={moment().format("YYYY-MM-DD")}
                />
              </Col>
              <Col md={2} col={12}>
                <label>Date To</label>
                <input
                  type="date"
                  className="form-control"
                  name="toDate"
                  value={filters.toDate}
                  onChange={handleSearchChanges}
                  max={moment().format("YYYY-MM-DD")}
                />
              </Col>
              <Col md={2} col={12}>
                <label>Airline</label>
                <CommonAutoComplete
                  name="airlineWise"
                  placeholder="Select Airline"
                  api={getAirlineDetailsForReport}
                  value={filters.airlineWise}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      airlineWise: selected,
                    }));
                  }}
                />
              </Col>
              <Col md={2} col={12}>
                <label>Origin (From)</label>
                <CommonAutoComplete
                  name="fromOrigin"
                  placeholder="Select Origin"
                  api={getAirportsDetailsForReport}
                  value={filters.fromOrigin}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      fromOrigin: selected,
                    }));
                  }}
                />
              </Col>
              <Col md={2} col={12}>
                <label>Destination (To)</label>
                <CommonAutoComplete
                  name="destinationWise"
                  placeholder="Select Destination"
                  api={getAirportsDetailsForReport}
                  value={filters.destinationWise}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      destinationWise: selected,
                    }));
                  }}
                />
              </Col>
              <Col md={3} col={12}>
                <label>Country</label>
                <CommonAutoComplete
                  name="countryId"
                  placeholder="Select Country"
                  api={getCountryDetailsForReport}
                  value={filters.countryId}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      countryId: selected,
                    }));
                  }}
                />
              </Col>
              <Col md={3} col={12}>
                <label>State</label>
                <CommonAutoComplete
                  name="stateId"
                  placeholder="Select State"
                  api={getStateDetailsForReport}
                  extraParams={{
                    countryId: filters?.countryId?.id,
                  }}
                  value={filters.stateId}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      stateId: selected,
                    }));
                  }}
                />
              </Col>
              <Col md={3} col={12}>
                <label>Gateway</label>
                <CommonAutoComplete
                  name="supplierWise"
                  placeholder="Select Gateway"
                  api={getSupplierForReport}
                  value={filters.supplierWise}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      supplierWise: selected,
                    }));
                  }}
                />
              </Col>
              <Col md={3} col={12}>
                <label>Sales Person</label>
                <CommonAutoComplete
                  name="SalesEecutiveId"
                  placeholder="Select Sales"
                  api={getSalesUserForReport}
                  value={filters.SalesEecutiveId}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      SalesEecutiveId: selected,
                    }));
                  }}
                />
              </Col>

              <Col md={12}>
                <div className="text-info text-sm">* Select First Country</div>
              </Col>
            </Row> */}
            {/* <Row>
              <Col>
                <div
                  style={{
                    fontSize: 12.5,
                    color: "red",
                    display: "flex",
                    gap: 16,
                  }}
                >
                  <span>
                    ● Regional Sales Manager → Sales Manager → Area Sales
                    Manager → Senior Executive → Sales Person
                  </span>
                </div>
              </Col>
            </Row> */}

            <Row>
              {/* <Col md={4} col={12}>
                <label>Regional Manager</label>

                <HierarchyAutoComplete
                  name="RegionalManagerId"
                  placeholder="Regional Manager"
                  api={getRegionalManagerAutoComplete}
                  value={filters.RegionalManagerId}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      RegionalManagerId: selected,

                      // reset child dropdowns
                      SalesManagerId: null,
                      AreaSalesManagerId: null,
                      SeniorEecutiveId: null,
                      SalesEecutiveId: null,
                    }));
                  }}
                />
              </Col>

              <Col md={4} col={12}>
                <label>Sales Manager</label>

                <HierarchyAutoComplete
                  name="SalesManagerId"
                  placeholder="Sales Manager"
                  api={getSalesManagerAutoCompleteForReport}
                  parentId={filters?.RegionalManagerId?.id}
                  value={filters.SalesManagerId}
                  isDisabled={!filters?.RegionalManagerId}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      SalesManagerId: selected,

                      AreaSalesManagerId: null,
                      SeniorEecutiveId: null,
                      SalesEecutiveId: null,
                    }));
                  }}
                />
              </Col>

              <Col md={4} col={12}>
                <label>Area Sales Manager</label>

                <HierarchyAutoComplete
                  name="AreaSalesManagerId"
                  placeholder="Area Sales Manager"
                  api={getAreaSalesManagerAutoCompleteForReport}
                  parentId={filters?.SalesManagerId?.id}
                  value={filters.AreaSalesManagerId}
                  isDisabled={!filters?.SalesManagerId}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      AreaSalesManagerId: selected,

                      SeniorEecutiveId: null,
                      SalesEecutiveId: null,
                    }));
                  }}
                />
              </Col> */}

              <Col md={6} col={12}>
                <label>Senior Executive</label>
                <SeniorExecutiveAutocomplete
                  value={filters.SeniorEecutiveId}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      SeniorEecutiveId: selected,

                      SalesEecutiveId: null,
                    }));
                  }}
                />
                {/* <HierarchyAutoComplete
                  name="SeniorEecutiveId"
                  placeholder="Senior Executive"
                  api={getSeniorExecutiveAutoCompleteForReport}
                  parentId={1}
                  value={filters.SeniorEecutiveId}
                  // isDisabled={!filters?.AreaSalesManagerId}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      SeniorEecutiveId: selected,

                      SalesEecutiveId: null,
                    }));
                  }}
                /> */}
              </Col>

              {/* <Col md={4} col={12}>
                <label>Sales Person</label>

                <HierarchyAutoComplete
                  name="SalesEecutiveId"
                  placeholder="Sales Executive"
                  api={getSalesExecutiveAutoCompleteForReport}
                  parentId={filters?.SeniorEecutiveId?.id}
                  value={filters.SalesEecutiveId}
                  isDisabled={!filters?.SeniorEecutiveId}
                  onChange={(selected) => {
                    setFilters((prev) => ({
                      ...prev,
                      SalesEecutiveId: selected,
                    }));
                  }}
                />
              </Col> */}

              <Col md={6} className="d-flex justify-content-end mt-3">
                <button
                  className="btn btn-outline-primary me-2"
                  onClick={handleSearch}
                >
                  <MdSearch size={18} />
                </button>

                <button
                  className="btn btn-outline-primary"
                  onClick={refreshFilter}
                >
                  <MdOutlineRefresh size={18} />
                </button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <HandyScroll>
        <div
          className="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="id"
            data={data}
            columns={
              canEdit ? columns : columns.filter((x) => x.text !== "Action")
            }
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
    </>
  );
}

export default SeniorSalesExecutive;
